import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import EventTileEntity from "../EventTileEntity";

class ToymakersWorkshopBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.CHRISTMAS;

	public static readonly frameName = FrameName.TOYMAKERS_WORKSHOP;
}

export default ToymakersWorkshopBuildingTileEntity;
